/**
 * CheTuo Web — Shop admin layout with sidebar navigation.
 */

import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { AppShell } from './AppShell';
import { listMyShops } from '../api/shop';
import { useQuery } from '@tanstack/react-query';
import { tokenStorage } from '../api/client';

const NAV_GROUPS = [
  {
    items: [
      { path: '/shop-admin/dashboard', label: '门店概览' },
      { path: '/shop-admin/orders', label: '工单管理' },
      { path: '/shop-admin/customers', label: '客户车辆' },
    ],
  },
  {
    title: '经营',
    items: [
      { path: '/shop-admin/payment-flow', label: '收款流水' },
      { path: '/shop-admin/inventory', label: '库存配件' },
      { path: '/shop-admin/staff', label: '员工权限' },
      { path: '/shop-admin/reports', label: '经营报表' },
    ],
  },
  {
    items: [{ path: '/shop-admin/settings', label: '门店设置' }],
  },
];

export function Layout(): React.JSX.Element {
  const navigate = useNavigate();
  const { user, isLoggedIn, logout } = useAuth();

  const { data: shops } = useQuery({
    queryKey: ['shops'],
    queryFn: listMyShops,
  });

  if (!isLoggedIn) {
    return <Navigate to="/shop-admin/login" replace />;
  }

  const handleLogout = () => {
    logout();
    navigate('/shop-admin/login');
  };

  const handleShopChange = (shopId: string) => {
    tokenStorage.setShopId(shopId);
    window.location.reload();
  };

  const currentShopId = tokenStorage.getShopId();

  return (
    <AppShell
      title="车妥"
      subtitle="门店管理后台"
      headerTitle={user?.displayName ?? user?.phone ?? ''}
      headerSubtitle={user?.phone}
      headerActions={
        <div className="hidden items-center gap-2 text-sm text-gray-600 md:flex">
          <span>当前门店</span>
          <select
            value={currentShopId ?? ''}
            onChange={(e) => handleShopChange(e.target.value)}
            className="h-9 rounded-lg border border-gray-300 bg-white px-3 py-1.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            {shops?.map((shop) => (
              <option key={shop.id} value={shop.id}>
                {shop.name}
              </option>
            ))}
          </select>
        </div>
      }
      groups={NAV_GROUPS}
      onLogout={handleLogout}
      footer={
        <div className="px-3">
          <p className="truncate text-xs text-gray-500">{user?.displayName ?? user?.phone}</p>
          <p className="text-xs text-gray-400">{user?.phone}</p>
        </div>
      }
    />
  );
}
